<template>
    <form ref="form" :action="route('library.backups.create')" method="POST">
        <input name="_token" type="hidden" :value="csrfToken">
        <div class="img-container">
            <img src="/static/images/backup.png" alt="backup icon">
        </div>
        <app-input
            name="name"
            :is-required="true"
            placeholder="Backup name"
        ></app-input>
        <app-button submit="true" type="primary">
            Create backup
        </app-button>
        <app-button @click="cancel">
            Cancel
        </app-button>
    </form>
</template>

<script>
    export default {
        computed: {
            csrfToken() {
                return document.querySelector('meta[name="csrf-token"]').content;
            }
        },
        methods: {
            cancel() {
                this.$emit('close');
            }
        }
    };
</script>

<style lang="scss" scoped>
    form {
        margin: 0.75rem;

        & > div.img-container {
            margin: 0.75rem;
            display: flex;
            justify-content: center;
            align-items: center;

            & > img {
                width: 100px;
            }
        }

        & > button {
            margin-top: 0.75rem;
        }
    }
</style>


